export default {
    data() {
        return {
            PROCESS_STATUS_PROCESSING: 1,
            PROCESS_STATUS_FINISHED: 2,
            PROCESS_STATUS_CANCELED: 3,
            PROCESS_STATUS_ERROR: 4,
        };
    },
};
